import React from 'react';
import { Link } from 'react-router-dom';
import {
    IconBrandFacebook,
    IconBrandInstagram,
    IconBrandTwitter,
    IconBrandWhatsapp,
} from '@tabler/icons-react';

const Footer: React.FC = () => {

    const number = "+971505411910";
    const whatsappLink = `https://wa.me/${number.replace('+', '')}?text=hlo`;
    const facebookLink = "https://www.facebook.com/triosintldubai";
    const instagramLink = "https://www.instagram.com/triosintldubai/";
    const twitterLink = "https://x.com/TriosInternati1";
    
    return (
        <footer className="w-full bg-white relative z-30">
            {/* Footer Bottom */}
            <div className="py-4 z-40 text-center text-gray-600 items-center justify-between mx-3 flex flex-col md:flex-row">
                <p>Trios &copy; 2025 All Rights Reserved</p>
                <div className='flex items-end gap-1 md:gap-5 flex-col md:flex-row'>
                    <div className="flex justify-center items-center md:items-baseline space-x-4 mt-4">
                        <a href={whatsappLink} className="text-white bg-[#59544b] rounded-full p-1 hover:text-[#ffffffd2]" target="_blank" rel="noopener noreferrer">
                            <IconBrandWhatsapp size={20} />
                        </a>
                        <a href={facebookLink} className="text-white bg-[#59544b] rounded-full p-1 hover:text-[#ffffffd2]" target="_blank" rel="noopener noreferrer">
                            <IconBrandFacebook size={20} />
                        </a>
                        <a href={twitterLink} className="text-white bg-[#59544b] rounded-full p-1 hover:text-[#ffffffd2]" target="_blank" rel="noopener noreferrer">
                            <IconBrandTwitter size={20} />
                        </a>
                        <a href={instagramLink} className="text-white bg-[#59544b] rounded-full p-1 hover:text-[#ffffffd2]" target="_blank" rel="noopener noreferrer">
                            <IconBrandInstagram size={20} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
